import { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import classes from "./helpCenter.module.scss";
import { useDispatch } from "react-redux";
import api from "@/services/api.service";
import { SAVE_HELP_CENTER_SUCCESS } from "@/redux/types/help_center.types";

const CategoryEditForm = ({ handleEditClose, title, description, show, post_id }) => {
	let initialState = {
		category: title,
		description: description,
	};

	const [category, setCategory] = useState(initialState);
	const { addToast } = useToasts();
	const dispatch = useDispatch();

	const handleInputChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setCategory({ ...category, [name]: value });
	};

	const handleOnSubmit = () => {
		const params = {
			title: category.category,
			description: category.description,
			post_id,
		};
		api.post("/admin/update_category", params).then((response) => {
			addToast(response.message, {
				appearance: "success",
			});
			dispatch({
				type: SAVE_HELP_CENTER_SUCCESS,
				payload: {
					questions: response.data.questions.data,
				},
			});
			handleEditClose();
		});
		setCategory(initialState);
	};
	return (
		<Modal show={show} onHide={handleEditClose} backdrop="static" keyboard={false} size="md">
			<Modal.Header closeButton>
				<Modal.Title>Agregar una nueva categoría</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group>
						<Form.Label>Nombre de categoría</Form.Label>
						<Form.Control
							type="text"
							placeholder="Ingresa el nombre de la categoría"
							name="category"
							value={category.category}
							onChange={handleInputChange}
						/>
					</Form.Group>
					<Form.Group>
						<Form.Label>Descripción de la categoria</Form.Label>
						<Form.Control
							type="text"
							placeholder="Ingresa la descripción de la categoría"
							name="description"
							value={category.description}
							onChange={handleInputChange}
						/>
					</Form.Group>
					<div className={`${classes.form_button}`}>
						<Button onClick={handleOnSubmit} className={`${classes.button}`}>
							Guardar
						</Button>
					</div>
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default CategoryEditForm;
